const SNACKBAR_SHOW_MESSAGE = 'SNACKBAR_SHOW_MESSAGE';
const SNACKBAR_HIDE_MESSAGE = 'SNACKBAR_HIDE_MESSAGE';

export { SNACKBAR_SHOW_MESSAGE, SNACKBAR_HIDE_MESSAGE };
